import { render, staticRenderFns } from "./QStatsSubmittedChart.vue?vue&type=template&id=3b6d5f7a&"
import script from "./QStatsSubmittedChart.vue?vue&type=script&lang=js&"
export * from "./QStatsSubmittedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports